// export const api_url = "http://localhost:8000/"
export const api_url = "https://apiv1.anell.edu.gh/"